import initialState from 'redux/initialState';
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { IncentiveOfferOperation } from 'modules/incentivesMarket/types';

type IncentiveOfferOperationAction = {
  type: string;
  incentiveOfferOperations?: IncentiveOfferOperation[];
  incentiveOfferOperation?: IncentiveOfferOperation;
  incentiveOfferOperationId?: string;
};

const resetStateSociety = () => initialState.incentiveOfferOperations;

const getIncentiveOfferOperations = (action: IncentiveOfferOperationAction) =>
  action.incentiveOfferOperations;

const createIncentiveOfferOperation = (
  incentiveOfferOperations: IncentiveOfferOperation[],
  action: IncentiveOfferOperationAction
) => [action.incentiveOfferOperation, ...incentiveOfferOperations];

const updateIncentiveOfferOperation = (
  incentiveOfferOperations: IncentiveOfferOperation[],
  action: IncentiveOfferOperationAction
) =>
  incentiveOfferOperations?.map((operation: IncentiveOfferOperation) =>
    operation._id === action?.incentiveOfferOperation?._id
      ? action.incentiveOfferOperation
      : operation
  );

const deleteIncentiveOfferOperation = (
  incentiveOfferOperations: IncentiveOfferOperation[],
  action: IncentiveOfferOperationAction
) =>
  incentiveOfferOperations?.filter(
    (operation: IncentiveOfferOperation) =>
      operation._id !== action.incentiveOfferOperationId
  );

export default function reducer(
  incentiveOfferOperations = initialState.incentiveOfferOperations,
  action: IncentiveOfferOperationAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.GET_INCENTIVE_OFFER_OPERATIONS:
      return getIncentiveOfferOperations(action);

    case actionTypes.CREATE_INCENTIVE_OFFER_OPERATION:
      return createIncentiveOfferOperation(incentiveOfferOperations, action);

    case actionTypes.UPDATE_INCENTIVE_OFFER_OPERATION:
      return updateIncentiveOfferOperation(incentiveOfferOperations, action);

    case actionTypes.DELETE_INCENTIVE_OFFER_OPERATION:
      return deleteIncentiveOfferOperation(incentiveOfferOperations, action);

    default:
      return incentiveOfferOperations;
  }
}
